import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { ISiteOIDCConfiguration } from '../types/ISiteOIDCConfiguration';

export interface ISiteOIDCConfigurationViewModel extends IResult {
  knownProviderAliases: string[];
  configuration: ISiteOIDCConfiguration;
}

export class GetOrCreateSiteOIDCConfigurationViewModelRequest extends Request<{}, ISiteOIDCConfigurationViewModel> {
  constructor() {
    super('getOrCreateSiteOIDCConfigurationViewModel', {});
  }
}
